/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerDto2 } from '../../models/customer-dto-2';
import { CustomerShowResponse2 } from '../../models/customer-show-response-2';

export interface PatchCustomerUpdate$Params {
  id: string;
      body: CustomerDto2
}

export function patchCustomerUpdate(http: HttpClient, rootUrl: string, params: PatchCustomerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomerShowResponse2>> {
  const rb = new RequestBuilder(rootUrl, patchCustomerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CustomerShowResponse2>;
    })
  );
}

patchCustomerUpdate.PATH = '/v1/customer/{id}';
